import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { DevExtremeModule } from 'devextreme-angular';
import { AppInformationService, AuthService, CdrUnitOfWork } from 'src/app/core/core.module';
import { StorageDumpSite } from 'src/app/core/model/storage-dump-site';
import { TonExpense } from 'src/app/core/model/ton-expense';
import { BaseDialogComponent } from 'src/app/shared/base-dialog/base-dialog.component';
import { AddressLookupComponent } from 'src/app/shared/components/address-lookup/address-lookup.component';
import { confirm } from 'src/app/shared/shared.module';

@Component({
    selector: 'app-storage-dump-site-detail',
    templateUrl: './storage-dump-site-detail.component.html',
    styleUrls: ['./storage-dump-site-detail.component.scss'],
    standalone: true,
    imports: [DevExtremeModule, AddressLookupComponent]
})
export class StorageDumpSiteDetailComponent extends BaseDialogComponent<any> implements OnInit {
    storageDumpSite: StorageDumpSite;
    success: boolean = false;
    tonExpenses: TonExpense[];

    constructor(
        private uow: CdrUnitOfWork,
        private appInfo: AppInformationService,
        private authService: AuthService
    ) {
        super();
    }

    async ngOnInit() {
        if (!this.storageDumpSite) this.storageDumpSite = this.createStorageDumpSite();
        this.tonExpenses = await this.uow.tonExpenses.whereActive('displayOrder');
    }

    createStorageDumpSite() {
        return this.uow.storageDumpSites.createEntity({
            created: moment(new Date()).toDate(),
            createdBy: this.authService.userValue.userName
        });
    }

    async locationChanged(addressLookup) {
        if (!addressLookup) return;

        if (
            this.storageDumpSite.address1 ||
            this.storageDumpSite.address2 ||
            this.storageDumpSite.city ||
            this.storageDumpSite.state ||
            this.storageDumpSite.zip ||
            this.storageDumpSite.latitude ||
            this.storageDumpSite.longitude
        ) {
            const result = await confirm(`Are you sure you want to override existing address data?`, `${this.appInfo.company}`);
            if (!result) {
                return;
            }
        }
        this.storageDumpSite.address1 = !!addressLookup.addressLabel ? addressLookup.addressLabel : addressLookup.placeLabel;
        // this.storageDumpSite.address2 = addressLookup.county;
        this.storageDumpSite.city = addressLookup.city;
        this.storageDumpSite.state = addressLookup.stateCode;
        this.storageDumpSite.zip = addressLookup.postalCode;
        this.storageDumpSite.latitude = addressLookup.latitude;
        this.storageDumpSite.longitude = addressLookup.longitude;
        this.storageDumpSite.county = addressLookup.county.replace(' County', '');

        // await this.setDistance();
    }

    save = async () => {
        await this.uow.commit();
        this.success = true;
        this.hide({ success: this.success, storageDumpSite: this.storageDumpSite });
    };

    saveAndNew = async () => {
        await this.uow.commit();
        this.success = true;
        this.storageDumpSite = this.createStorageDumpSite();
    };

    cancel = async () => {
        if (!(await confirm('Are you sure you want to cancel changes?', this.appInfo.appTitle))) return false;
        this.uow.rollback();
        this.close();
    };

    close = () => {
        this.hide({ success: this.success });
    };

    hasChanges() {
        return this.uow.hasChanges();
    }
}
